export default __webpack_public_path__ + "static/media/HEELS-MASTERS-wwa.c6d5e8f8.jpg";